// Copyright (c) 2021 JCA Electronics , Winnipeg, MB. All rights reserved.
import { GPSLocation } from '@/flightpath-components/models/GPSLocation';

export class PathHelper {
  /*
    Accepted error tolerance if a lat/lng are considered equal, this value equates to roughly 12mm distance apart between points
  */
  private static espilon = 1e-7;

  /*
      Convert a list of GPSLocation points to a list of simple points
    */
  static removeDuplicateSuccessivePoints(points: GPSLocation[]): GPSLocation[] {
    // make sure the list of points is distinct
    const uniquePath: GPSLocation[] = [];
    let previousLocation: GPSLocation | null = null;

    points.forEach((location) => {
      if (previousLocation != null) {
        if (!this.locationssAreTheSame(location, previousLocation)) {
          uniquePath.push(location);
        }
      } else {
        uniquePath.push(location);
      }

      previousLocation = location;
    });

    return uniquePath;
  }

  /*
    Checks if two locations are at same latitude and longitude
  */
  private static locationssAreTheSame(point1: GPSLocation, point2: GPSLocation): boolean {
    const latDif = Math.abs(point1.Latitude - point2.Latitude);
    const lngDif = Math.abs(point1.Longitude - point2.Longitude);

    return latDif < this.espilon && lngDif < this.espilon;
  }
}
